const MONGO_OBJECT_ID_RE = /^[a-fA-F0-9]{24}$/

/** Normalize API/Mongoose id values to a 24-char hex string, or null if invalid. */
export function resolveDocumentMongoId(value: unknown): string | null {
    if (value == null) return null
    if (typeof value === 'object') {
        const record = value as Record<string, unknown>
        if (record._id != null) return resolveDocumentMongoId(record._id)
        if (record.id != null && record.id !== value) return resolveDocumentMongoId(record.id)
    }
    const trimmed = String(value).trim()
    return MONGO_OBJECT_ID_RE.test(trimmed) ? trimmed : null
}
